import { WidgetBase, WidgetHost } from '@/core/widgets/export';
import { RouteObject } from 'react-router-dom';
import AppRail from '@/core/deep-dive/components/app-rail';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

export interface DeepDivePreferences {
  pinnedAppIds: string[];
}

// Hosts the app rail as the side panel's "Widgets" tab — not itself a deep-dive app.
export class DeepDiveRailWidget implements WidgetBase {
  get defaultRoute(): string {
    return '';
  }

  get defaultTitle(): string {
    return 'Widgets';
  }

  defaultPreferences(): DeepDivePreferences {
    return { pinnedAppIds: [] };
  }

  hasPermission(permissions: string[]): Promise<boolean> {
    return Promise.resolve(true);
  }

  get headerPanel(): JSX.Element {
    return (
      <>
        <FontAwesomeIcon icon={faCircleInfo} /> Widgets
      </>
    );
  }

  get id(): string {
    return 'deep-dive';
  }

  initialize(host: WidgetHost): void {}

  get routes(): RouteObject[] {
    return [
      {
        path: '',
        element: <AppRail />,
      },
    ];
  }
}
